import React, { useState, useEffect } from "react";
import NeStates from "./neStates.json";
import NeDistricts from "./neDistricts.json";
import NeBlocks from "./neBlocks.json";
import DataTable from "datatables.net-dt";

const FilterDistrictsStatesAndBlocks = ({ activeTab }) => {
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");

  const filteredDistricts = NeDistricts.filter(
    (district) => district.state === selectedState
  );
  const filteredBlocks = NeBlocks.filter(
    (block) =>
      block.state === selectedState && block.district === selectedDistrict
  );

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
          <label htmlFor="">State</label>
          <div class="form-group group">
            <select
              id="filterState"
              class="form-control"
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
            >
              {NeStates.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
          <label htmlFor="">Districts</label>
          <div class="form-group group">
            <select
              id="filterDistrict"
              class="form-control"
              onChange={(e) => setSelectedDistrict(e.target.value)}
            >
              <option value="">--- Select ---</option>
              {filteredDistricts.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-contact1">
          <label htmlFor="">Blocks</label>
          <div class="form-group group">
            <select id="filterBlock" class="form-control">
              <option value="">--- Select ---</option>
              {filteredBlocks.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-contact1">
          <div class="d-flex justify-content-center align-items-center">
            <button id="filterBtn" className="quick-btn gray-btn mt-4">
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterDistrictsStatesAndBlocks;
